import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {Loner} from "../../Loner";
import {SimpleReelModelState} from "../../../core/reel/ReelInterfaces";
import {SimpleReelModelEventData} from "../../reels/LonerReelModel";
import {ArrayUtils} from "../../utils/ArrayUtils";
import {LonerSound} from "../../sound/LonerSound";
import {LonerStatics} from "../../LonerStatics";
import {LonerGameMode} from "../../server/LonerGameMode";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {LonerModel} from "../../LonerModel";

/**
 * Created by Jerker Nord on 2023-01-16.
 */

export class LonerSpinResultPresentation implements SimplePresentation {

    protected _tl: gsap.core.Timeline;
    protected _stoppedReels: boolean[];
    protected _reelsReadyToStop: boolean[];
    protected _controller: SimplePresentationRunnerController;
    private _scattersLandedInSpinCounter: number;

    public shouldRun(): boolean {
        return true;
    }

    public start(controller: SimplePresentationRunnerController): void {
        this._controller = controller;
        this._scattersLandedInSpinCounter = 0;
        this._reelsReadyToStop = [false, false, false, false, false];
        for (let i: number = 0; i < Loner.model.gameData.reels.length; i++) {
            Loner.allReelView.mainReelModels[i].events?.once(SimpleReelModelState.READY_TO_STOP, (data: SimpleReelModelEventData) => this.onReelReadyToStop(data));
            Loner.allReelView.mainReelModels[i].getReadyToStop();
        }
    }

    protected onReelReadyToStop(data: SimpleReelModelEventData) {
        this._reelsReadyToStop[data.reel] = true;
        if (ArrayUtils.isAllTrue(this._reelsReadyToStop)) {
            this.doStop();
        }
    }

    //Override
    protected doStop(): void {
    }

    protected skip(): void {
        this._controller.setSkipCallback();
        this._tl.totalProgress(1);
    }

    protected onReelBounce(data: SimpleReelModelEventData): void {
        const isPreWinPossible: boolean = (Loner.model.preWinPositions.findIndex(arr => arr.includes(true))) > -1,
            tl: gsap.core.Timeline = gsap.timeline();
        if (isPreWinPossible && data.reel >= 2 && !Loner.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            if (data.reel === 2) {
                for (let reelId: number = 0; reelId <= 2; reelId++) {
                    tl.add(this.playPreWinAnimOnSymbols(reelId), 0);
                }
            } else {
                tl.add(this.playPreWinAnimOnSymbols(data.reel), 0);
            }
        }

        if (Loner.model.bigWildOnReels[data.reel] == true && data.reel == Loner.model.bigWildSize) {
            if (Loner.model.bigWildSize == 3 && Loner.model.bigWildReelPosition > 0 && Loner.model.bigWildReelPosition < 8) {
                //Only play sound if 3x3 lands in visible area
                Loner.soundPlayer.playSound(LonerSound.BIG_SYMBOL_LAND);
            } else if (Loner.model.bigWildReelPosition > 1 && Loner.model.bigWildReelPosition < 7) {
                //Only play sound if 2x2 lands in visible area
                Loner.soundPlayer.playSound(LonerSound.BIG_SYMBOL_LAND);
            }
        }

        if (data.reel == 2 && Loner.model.scattersLanded[0] > -1 && Loner.model.scattersLanded[2] == -1){
            Loner.scatterPool.getScatterSymbolOnReel(0).getTVTransformTL();
        }

        if (Loner.model.scattersLanded[data.reel] > -1) {
            if (Loner.model.instantTVReveal[data.reel]) {
                Loner.scatterPool.getScatterSymbolOnReel(data.reel).getTVTransformTL();
            } else {
                Loner.scatterPool.getScatterSymbolOnReel(data.reel).getTVLandTL();
            }
            this._scattersLandedInSpinCounter++;
            if (this._scattersLandedInSpinCounter == 1) {
                if (Loner.model.instantTVReveal[data.reel] == false) {
                    if(data.reel===0){
                        if(Loner.apiPlugin.betFeatureController.getActiveBetFeature()?.name!=="BOOSTED_BET"){
                            Loner.soundPlayer.playSound(LonerSound.SCATTER_1_LAND);
                        }
                    }else {
                        Loner.soundPlayer.playSound(LonerSound.SCATTER_1_LAND);
                    }
                }
                if (Loner.model.gameData.wasFeatureBuy && (Loner.model.featureTrigger === LonerStatics.MAX_WIN_TRIGGER || Loner.model.featureTrigger === LonerStatics.MAX_WIN_TEASE_TRIGGER)) {
                    Loner.soundPlayer.playSound(LonerSound.GM_LETTER_M);
                }
            } else if (this._scattersLandedInSpinCounter == 2) {
                if (Loner.model.instantTVReveal[data.reel] == false) {
                    Loner.soundPlayer.playSound(LonerSound.SCATTER_2_LAND);
                }
                if (Loner.model.gameData.wasFeatureBuy && (Loner.model.featureTrigger === LonerStatics.MAX_WIN_TRIGGER || Loner.model.featureTrigger === LonerStatics.MAX_WIN_TEASE_TRIGGER)) {
                    Loner.soundPlayer.playSound(LonerSound.GM_LETTER_A);
                }
            } else if (this._scattersLandedInSpinCounter == 3) {
                if (Loner.model.instantTVReveal[data.reel] == false) {
                    Loner.soundPlayer.playSound(LonerSound.SCATTER_3_LAND);
                    Loner.soundPlayer.stopSound(LonerSound.SCATTER_1_LAND);
                    Loner.soundPlayer.stopSound(LonerSound.SCATTER_2_LAND);
                }

            }
        }

        Loner.soundPlayer.playSound(LonerSound.REELS_LANDING[data.reel]);
    }

    protected onReelStop(data: SimpleReelModelEventData, controller: SimplePresentationRunnerController):void {
        if(Loner.apiPlugin.settings.get(APISetting.FAST_SPIN,false) || (Loner.model.mode===LonerGameMode.NORMAL && Loner.model.nextMode !== LonerGameMode.NORMAL && Loner.model.wasFeatureBuy)){
            if(data.reel===4){
                for(let idx:number=0;idx<Loner.model.scattersLanded.length;idx++){
                    if(Loner.model.scattersLanded[idx]>-1){
                        Loner.shake(0.1,60);
                        break;
                    }
                }
            }
        }else if(Loner.model.scattersLanded[data.reel]>-1){
            Loner.shake(0.1,60);
        }

        if (data.reel == 2 && Loner.model.scatterAnticipationReels[4] == true){
            Loner.anticipationView.activateScatterAnticipation();
        }
        this._stoppedReels[data.reel] = true;
        if (ArrayUtils.isAllTrue(this._stoppedReels)) {
            if((Loner.model.mode===LonerGameMode.NORMAL && Loner.model.nextMode===LonerGameMode.NORMAL) && Loner.model.scattersLanded[0]>-1 && Loner.model.scattersLanded[2]>-1 && Loner.model.scatterAnticipationReels[4]){
                if(!Loner.isGodModeRound){
                    Loner.soundPlayer.playSound(LonerSound.SCATTER_ANTICIPATION_FAIL);
                }
            }
            Loner.anticipationView.deActivateScatterAnticipation();
            this.completePresentation(controller);
        }
    }

    protected completePresentation(controller: SimplePresentationRunnerController) {
        Loner.soundPlayer.stopSound(LonerSound.REELS_SPINNING);
        controller.finish();
    }

    private playPreWinAnimOnSymbols(reelId: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            preWinPositions: boolean[][] = Loner.model.preWinPositions;
        let playSoundOnceFlag: boolean = true;
        for (let symId: number = 0; symId < preWinPositions[reelId].length; symId++) {
            const symName: string = Loner.model.reels[reelId][symId];
            if (preWinPositions[reelId][symId]) {
                if (playSoundOnceFlag) {
                    tl.add(() => {
                        Loner.symOverlayAnimationsView.visible = true;
                        Loner.soundPlayer.playSound(LonerSound.WIN_BLINK);
                    }, 0)
                    playSoundOnceFlag = false;
                }
                tl.add(Loner.symOverlayAnimationsView.playPreWinHighlightAnim(reelId, symId, symName), 0);
            }
        }
        tl.add(() => {
            Loner.symOverlayAnimationsView.visible = false;
        })
        return tl;
    }
}